<div class="wrapper">
    <div class="center-object">
        <img src="assets/images/warning.svg" class="error-icon" alt="">
        <p class="error-message">{{message}}</p> 
    </div>
</div>